// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-bundle-removal-dialog {
  padding: 20px;
  max-width: 600px;
  background: #fff !important;
  opacity: 1 !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
}
.confirm-bundle-removal-dialog .dialog-header {
  margin-bottom: 20px;
}
.confirm-bundle-removal-dialog .dialog-header h2 {
  color: #1976d2;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}
.confirm-bundle-removal-dialog .dialog-content {
  margin-bottom: 25px;
}
.confirm-bundle-removal-dialog .dialog-content p {
  margin-bottom: 15px;
  line-height: 1.5;
  color: #333;
}
.confirm-bundle-removal-dialog .dialog-content .instructions {
  background-color: #e3f2fd;
  padding: 15px;
  border-radius: 8px;
  margin: 20px 0;
  border-left: 4px solid #1976d2;
}
.confirm-bundle-removal-dialog .dialog-content .instructions h4 {
  margin: 0 0 10px 0;
  color: #1976d2;
  font-size: 1rem;
}
.confirm-bundle-removal-dialog .dialog-content .instructions ol {
  margin: 0;
  padding-left: 20px;
}
.confirm-bundle-removal-dialog .dialog-content .instructions ol li {
  margin-bottom: 8px;
  color: #555;
}
.confirm-bundle-removal-dialog .dialog-content .bundle-info {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin: 20px 0;
}
.confirm-bundle-removal-dialog .dialog-content .bundle-info h4 {
  margin: 0 0 10px 0;
  color: #555;
  font-size: 1rem;
}
.confirm-bundle-removal-dialog .dialog-content .bundle-info ul {
  margin: 0;
  padding-left: 20px;
}
.confirm-bundle-removal-dialog .dialog-content .bundle-info ul li {
  margin-bottom: 8px;
  color: #666;
}
.confirm-bundle-removal-dialog .dialog-content .bundle-info ul li strong {
  color: #333;
}
.confirm-bundle-removal-dialog .dialog-content .warning {
  background-color: #fff3e0;
  padding: 15px;
  border-radius: 8px;
  margin: 20px 0;
  border-left: 4px solid #ff9800;
}
.confirm-bundle-removal-dialog .dialog-content .warning p {
  margin: 0;
  color: #e65100;
  font-weight: 500;
}
.confirm-bundle-removal-dialog .dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.confirm-bundle-removal-dialog .dialog-actions .cancel-btn,
.confirm-bundle-removal-dialog .dialog-actions .proceed-btn {
  min-height: 36px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}
.confirm-bundle-removal-dialog .dialog-actions .cancel-btn {
  color: #666;
  border: 1px solid #ddd;
  background-color: #fff;
}
.confirm-bundle-removal-dialog .dialog-actions .cancel-btn:hover {
  background-color: #f5f5f5;
  border-color: #bbb;
}
.confirm-bundle-removal-dialog .dialog-actions .proceed-btn {
  background-color: #1976d2;
  color: white;
  border: 1px solid #1976d2;
}
.confirm-bundle-removal-dialog .dialog-actions .proceed-btn:hover {
  background-color: #1565c0;
  border-color: #1565c0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/confirm-bundle-removal-dialog/confirm-bundle-removal-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;EACA,wCAAA;UAAA,gCAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,cAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AACN;AAGE;EACE,mBAAA;AADJ;AAGI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AADN;AAII;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AAFN;AAIM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAFR;AAKM;EACE,SAAA;EACA,kBAAA;AAHR;AAKQ;EACE,kBAAA;EACA,WAAA;AAHV;AAQI;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AANN;AAQM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AANR;AASM;EACE,SAAA;EACA,kBAAA;AAPR;AASQ;EACE,kBAAA;EACA,WAAA;AAPV;AASU;EACE,WAAA;AAPZ;AAaI;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AAXN;AAaM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AAXR;AAgBE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAdJ;AAgBI;;EAEE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAdN;AAiBI;EACE,WAAA;EACA,sBAAA;EACA,sBAAA;AAfN;AAiBM;EACE,yBAAA;EACA,kBAAA;AAfR;AAmBI;EACE,yBAAA;EACA,YAAA;EACA,yBAAA;AAjBN;AAmBM;EACE,yBAAA;EACA,qBAAA;AAjBR","sourcesContent":[".confirm-bundle-removal-dialog {\n  padding: 20px;\n  max-width: 600px;\n  background: #fff !important;\n  opacity: 1 !important;\n  backdrop-filter: none !important;\n  \n  .dialog-header {\n    margin-bottom: 20px;\n    \n    h2 {\n      color: #1976d2;\n      margin: 0;\n      font-size: 1.5rem;\n      font-weight: 600;\n    }\n  }\n  \n  .dialog-content {\n    margin-bottom: 25px;\n    \n    p {\n      margin-bottom: 15px;\n      line-height: 1.5;\n      color: #333;\n    }\n    \n    .instructions {\n      background-color: #e3f2fd;\n      padding: 15px;\n      border-radius: 8px;\n      margin: 20px 0;\n      border-left: 4px solid #1976d2;\n      \n      h4 {\n        margin: 0 0 10px 0;\n        color: #1976d2;\n        font-size: 1rem;\n      }\n      \n      ol {\n        margin: 0;\n        padding-left: 20px;\n        \n        li {\n          margin-bottom: 8px;\n          color: #555;\n        }\n      }\n    }\n    \n    .bundle-info {\n      background-color: #f5f5f5;\n      padding: 15px;\n      border-radius: 8px;\n      margin: 20px 0;\n      \n      h4 {\n        margin: 0 0 10px 0;\n        color: #555;\n        font-size: 1rem;\n      }\n      \n      ul {\n        margin: 0;\n        padding-left: 20px;\n        \n        li {\n          margin-bottom: 8px;\n          color: #666;\n          \n          strong {\n            color: #333;\n          }\n        }\n      }\n    }\n    \n    .warning {\n      background-color: #fff3e0;\n      padding: 15px;\n      border-radius: 8px;\n      margin: 20px 0;\n      border-left: 4px solid #ff9800;\n      \n      p {\n        margin: 0;\n        color: #e65100;\n        font-weight: 500;\n      }\n    }\n  }\n  \n  .dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    \n    .cancel-btn,\n    .proceed-btn {\n      min-height: 36px;\n      padding: 8px 16px;\n      border-radius: 4px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 100px;\n    }\n    \n    .cancel-btn {\n      color: #666;\n      border: 1px solid #ddd;\n      background-color: #fff;\n      \n      &:hover {\n        background-color: #f5f5f5;\n        border-color: #bbb;\n      }\n    }\n    \n    .proceed-btn {\n      background-color: #1976d2;\n      color: white;\n      border: 1px solid #1976d2;\n      \n      &:hover {\n        background-color: #1565c0;\n        border-color: #1565c0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
